import React, {useEffect} from 'react'
import Topbar from '../../components/topbar/Topbar'
import { useHistory } from 'react-router'
import {activateEmail} from '../../actions'
import {useDispatch, useSelector} from 'react-redux'
 
const {REACT_APP_D_CORE_URL} = process.env;

const AppUrl = REACT_APP_D_CORE_URL


const EmailValidation = ()=>{

    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {hasActivatedEmail}= state
        const {status} = hasActivatedEmail
        return{
            status
        }
    })

    const params = new URLSearchParams(window.location.search)
    const email = params.get('email')

    useEffect(()=>{
        if(email){
            dispatch(activateEmail(email))
        }
    },[email])

    return(
        <div className="email-validation-container">
            <Topbar hasName={true}/>
            <div className="email-validation-header">
            </div>
            <div className="email-validation-card">
                <span>{apiResponse.status}</span>
                <p></p>
                <h1>Login from here</h1>
                <button 
                    onClick={()=>window.open(`${AppUrl}`)}
                    >LOGIN</button>
            </div>
        </div>
    )

}
export default EmailValidation